module.exports = __webpack_public_path__ + "assets/jquery-mobile.a5573577.svg";